<div class="participant mdc-elevation--z3">
    <linear-progress :active="loading"></linear-progress>
    <div class="participant__logo">
        <img src="/static/monjin-logo-orange.png" alt="Monjin">
    </div>

    <div class="participant__heading">{{ heading }}</div>

    <div class="participant__subheading">Please enter your <strong>6 digit</strong> code</div>

    <pin-input class="participant__code" :error="errorCode !== 0" :length="6" :upperCase="true"
        v-model="participantCode" @input="onPinChange"></pin-input>

    <div v-if="invalidJoinCodeError" class="participant__error" v-html="invalidJoinCodeError"></div>
    <!-- <div v-if="errorCode === 1" class="participant__error">Please enter code.</div>
    <div v-if="errorCode === 2" class="participant__error">Oops, you have entered invalid code.</div>
    <div v-if="errorCode === 3" class="participant__error">Looks like there is some problem occured while joining interview.<br/> Please contact administrator.</div> -->

    <div v-if="loggingOutWarning" class="participant__warn">
        <div class="participant__warn__content">
            <mom-icon key="info" svgIcon="info" width="24" height="24"></mom-icon>
            {{ loggingOutWarning }}
        </div>
    </div>

    <div class="participant__terms">
        By clicking on confirm, you agree to monjin's <a class="participant__terms-link" href="https://www.monjin.com/home/terms" target="_blank">Terms of Service</a>
        <br/> and <a class="participant__terms-link" href="https://www.monjin.com/privacy-policy/" target="_blank">Privacy Policy</a>
    </div>

    <VueRecaptcha v-if="showCaptcha" class="participant__captcha" :sitekey="siteKey"
        :loadRecaptchaScript="true"
        badge="inline"
        @verify="setiAmNotRobot(true)"
        @error="setiAmNotRobot(false)"
        @expired="setiAmNotRobot(false)">
    </VueRecaptcha>

    <mom-button variant="raised" class="participant__confirm" @click="onConfirm" :disabled="disabled">Confirm</mom-button>
</div>
